<template>
  <div>
    <div style="margin-bottom:10px;">
      <Button type="primary" @click="openAddModal(0)">新增顶级菜单</Button>
    </div>

    <Table :columns="columns" :data="list" border />

    <!-- 新增/编辑菜单弹窗 -->
    <Modal v-model="modalVisible" :title="editMode ? '编辑菜单' : '新增菜单'" width="480" @on-cancel="resetForm">
      <Form :model="form" :rules="rules" ref="form" :label-width="90">
        <FormItem label="父级菜单">
          <Select v-model="form.parent_id" placeholder="不选则为顶级菜单">
            <Option :value="0">顶级菜单</Option>
            <Option v-for="m in topMenus" :key="m.id" :value="m.id">{{ m.menu_name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="菜单名称" prop="menu_name">
          <Input v-model="form.menu_name" placeholder="如：发货管理" />
        </FormItem>
        <FormItem label="路由Path" prop="path">
          <Input v-model="form.path" placeholder="如：/fahuo/fahuolist" />
        </FormItem>
        <FormItem label="图标">
          <Input v-model="form.icon" placeholder="iView 图标名，如：bookmark" />
        </FormItem>
        <FormItem label="排序">
          <InputNumber v-model="form.sort" :min="0" style="width:100px;" />
        </FormItem>
        <FormItem label="是否隐藏">
          <i-switch v-model="form.hidden" :true-value="1" :false-value="0" />
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="resetForm">取消</Button>
        <Button type="primary" @click="submitForm">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getMenuList, addMenu, updateMenu, deleteMenu } from '@/api/sysmanage';

export default {
  data() {
    return {
      list: [],
      topMenus: [],
      modalVisible: false,
      editMode: false,
      form: { id: null, parent_id: 0, menu_name: '', path: '', icon: '', sort: 0, hidden: 0 },
      rules: {
        menu_name: [{ required: true, message: '菜单名称不能为空', trigger: 'blur' }],
        path: [{ required: true, message: '路由Path不能为空', trigger: 'blur' }],
      },
      columns: [
        { title: 'ID', key: 'id', width: 70 },
        { title: '父级ID', key: 'parent_id', width: 90 },
        { title: '菜单名称', key: 'menu_name', width: 150 },
        { title: '路由Path', key: 'path' },
        { title: '图标', key: 'icon', width: 120 },
        { title: '排序', key: 'sort', width: 80 },
        {
          title: '是否隐藏', key: 'hidden', width: 100,
          render: (h, params) => h('span', params.row.hidden ? '是' : '否')
        },
        {
          title: '操作', key: 'action', width: 220, align: 'center',
          render: (h, params) => h('div', [
            h('Button', { props: { type: 'primary', size: 'small' }, style: { marginRight: '6px' }, on: { click: () => this.openEditModal(params.row) } }, '编辑'),
            h('Button', { props: { type: 'success', size: 'small' }, style: { marginRight: '6px' }, on: { click: () => this.openAddModal(params.row.id) } }, '添加子菜单'),
            h('Button', { props: { type: 'error', size: 'small' }, on: { click: () => this.handleDelete(params.row) } }, '删除'),
          ])
        }
      ]
    };
  },
  mounted() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      getMenuList({}).then(res => {
        this.list = res.data || [];
        this.topMenus = this.list.filter(m => m.parent_id === 0);
      }).catch(() => {});
    },
    openAddModal(parentId) {
      this.editMode = false;
      this.form = { id: null, parent_id: parentId || 0, menu_name: '', path: '', icon: '', sort: 0, hidden: 0 };
      this.modalVisible = true;
    },
    openEditModal(row) {
      this.editMode = true;
      this.form = { id: row.id, parent_id: row.parent_id, menu_name: row.menu_name, path: row.path, icon: row.icon || '', sort: row.sort || 0, hidden: row.hidden || 0 };
      this.modalVisible = true;
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        const api = this.editMode ? updateMenu : addMenu;
        api(this.form).then(() => {
          this.$Message.success(this.editMode ? '编辑成功' : '新增成功');
          this.modalVisible = false;
          this.fetchList();
        }).catch(() => {});
      });
    },
    handleDelete(row) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定删除菜单【${row.menu_name}】？子菜单也将一并删除。`,
        onOk: () => {
          deleteMenu({ id: row.id }).then(() => {
            this.$Message.success('删除成功');
            this.fetchList();
          }).catch(() => {});
        }
      });
    },
    resetForm() { this.modalVisible = false; this.$refs.form && this.$refs.form.resetFields(); }
  }
};
</script>
